import { useQuery } from "react-query";
import { getMesas } from "../../../services/api";

const useGetMesas = () => {
  return useQuery(["mesas"], () =>
    getMesas()
  ); // Save Itens in cache
};

export default useGetMesas;
